import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import OfferView from '../views/OfferView.vue'
import Offer1View from '../views/OfferView1.vue'
import Offer2View from '../views/OfferView2.vue'

import { getToken } from '@/utils/auth'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/offer',
		name: 'offer',
		meta: {
			requiresAuth: true
		},
		component: OfferView
	},
	{
		path: '/offer1',
		name: 'offer',
		meta: {
			requiresAuth: true
		},
		component: Offer1View
	},
	{
		path: '/offer2',
		name: 'offer',
		meta: {
			requiresAuth: true
		},
		component: Offer2View
	},
	{
		path: '/about',
		name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
	},
	{
		path: '/ask',
		name: 'ask',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Faq.vue')
	},
	{
		path: '/login',
		name: 'login',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
	},
	{
		path: '/register',
		name: 'register',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
	},
	{
		path: '/order',
		name: 'order',
		meta: {
			requiresAuth: true
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Order.vue')
	},
	{
		path: '/order_detail',
		name: 'order_detail',
		meta: {
			requiresAuth: true
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/OrderDetail.vue')
	},
	{
		path: '/matter',
		name: 'matter',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Matter.vue')
	},
	{
		path: '/guide',
		name: 'guide',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Guide.vue')
	},
	{
		path: '/contact',
		name: 'contact',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
router.beforeEach((to, from, next) => {
	const hasToken = getToken()

	// 不需要登录的页面

	const whiteList = ['/', '/login', '/register', '/about', '/ask']

	if (hasToken) {
		// 已登录，访问登录页直接首页

		if (to.path === '/login') {
			next('/')

			return
		}

		next()
	} else {
		// 未登录

		if (whiteList.includes(to.path)) {
			next()
		} else {
			next({
				path: '/login',

				query: {
					redirect: to.fullPath
				}
			})
		}
	}
})
export default router
